<template>
  <div class="table-component">
    <div class="tab__content__top" v-if="!hideTableTop">
      <div class="tab__content__top__left">
         <svg v-if="toggleContent && !state.showContents" @click="state.showContents = true" width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 11L6 6L1 1" stroke="#e00b5b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <svg v-if="toggleContent && state.showContents" @click="state.showContents = false" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.5 1.5L6.5 6.5L11.5 1.5" stroke="#e00b5b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <p v-if="!loading">{{ title }}</p>
      </div>
        <slot v-if="state.showContents || forceFilterSlot" name="filter"></slot>
          <div class="tab__content__top__right" v-if="!hideFilter">
        <Button
          buttonName="Clear Filter"
          :hideButton="showFliter && !state.openFilters"
          :onClick="clearFilterHandler"
          classes="basic-borderless"
        />
        <Button
          buttonName="Filter"
          :hideButton="!showFliter"
          :onClick="() => (state.openFilters = true)"
          classes="basic"
        />
        <div v-if="showExport" class="show-export">
          <Button
            buttonName="Export"
            :disabled="!contents.length"
            :onClick="
              () => (state.showExportOptions = !state.showExportOptions)
            "
            classes="basic"
          >
            <span>
              <svg
                fill="none"
                height="12"
                viewBox="0 0 14 18"
                width="14"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.25 0V12.4219L2.28906 8.46094L1.21094 9.53906L6.46094 14.7891L7 15.3047L7.53906 14.7891L12.7891 9.53906L11.7109 8.46094L7.75 12.4219V0H6.25ZM0.25 16.5V18H13.75V16.5H0.25Z"
                  fill="#e00b5b"
                />
              </svg>
            </span>
          </Button>
          <div class="export-options" v-if="state.showExportOptions">
            <div class="export-options__option" @click="exportfile('pdf')">
              PDF
            </div>
            <div class="export-options__option" @click="exportfile('csv')">
              CSV
            </div>
          </div>
        </div>
        <Button
          v-if="!hidePrimaryButton"
          :buttonName="primaryButtonName"
          :disabled="handlePrimaryButtonDisabled"
          :onClick="handlePrimaryButtonClick"
          classes="primary"
        />
      </div>
    </div>
    <slot :openFilters="state.openFilters"></slot>
    <slot v-if="!loading" name="tab"></slot>
    <div class="loader" v-if="loading">
      <span aria-hidden="true" class="spinner-border"></span>
    </div>
    <table class="table card-table" v-if="(!loading && !toggleContent) || (toggleContent && state.showContents && !loading)">
      <thead>
        <tr>
          <th
            v-for="(value, propertyName, index) in contents[0]"
            :class="
              propertyName == 'id' || propertyName == 'payout_reference'
                ? 'display-none'
                :  propertyName === 'STATUS' ? 'smaller-td' :''
            "
            :key="index"
          >
            <div v-if="propertyName == 'STATUS'"></div>
            <div
              v-else-if="propertyName.startsWith('STATUS-COVER')"
              :class="
                propertyName === 'PREEXISTING MERCHANTS' ? 'flex-center' : ''
              "
            ></div>

            <div
              v-else-if="
                !propertyName.startsWith('checkbox') &&
                !propertyName.startsWith('STATUS-COVER') &&
                !propertyName.startsWith('nocheckbox')
              "
              :class="
                propertyName === 'PREEXISTING MERCHANTS' ? 'flex-center' : ''
              "
            >
              {{ propertyName }}
            </div>
            <div
              v-else-if="
                (propertyName.endsWith('checkbox')) &&
                pageInfo.total != rowSelected.length
              "
              @click="()=>checkboxAll(contents[0])"
              class="checkbox-svg"
            >
              <img src="../assets/checked-box-some.svg" />
            </div>
            <div
              v-else-if="
                propertyName.endsWith('checkbox') &&
                pageInfo.total == rowSelected.length
              "
              @click="checkboxNone"
              class="checkbox-svg"
            >
              <img src="../assets/checked-box-all.svg" />
            </div>

            <div v-else>{{ propertyName }}</div>
          </th>
        </tr>
      </thead>
      <tbody
        v-for="(item, index) in contents"
        :key="index"
        :class="rowSelected && rowSelected.includes(item.id) ? 'green' : ''"
      >
        <router-link
          v-if="!noClickEvent"
          :event="routerClickEvent ? routerClickEvent : 'click'"
          :to="{
            name: singleDetailRouteName,
            params: {
              id: item.id,
              ...(additionalRouteName
                ? { [additionalRouteName]: item[additionalRouteKey] }
                : {}),
              ...(paramsObject ? paramsObject : {}),
            },
          }"
          tag="tr"
        >
          <td
            v-for="(value, propertyName, index) in item"
            :key="index"
            :class="
              propertyName == 'id' || propertyName == 'payout_reference'
                ? 'display-none'
                : propertyName === 'STATUS' ? 'smaller-td' :''
            "
          >
            <div v-if="propertyName === 'STATUS'">
              <StatusIndicator :type="value" />
            </div>
            <div v-else-if="propertyName === 'STATUS-COVER'" class="cover">
              <p>{{ capitalizeFirstLetter(value) }}</p>
            </div>
            <div v-else-if="propertyName.startsWith('checkbox')">
              <Checkbox
                :onChecked="onChecked"
                :id="item.id"
                :rowSelected="rowSelected"
              />
            </div>
            <div
                    v-else-if="
                propertyName.startsWith('nocheckbox')
              "
                    class="checkbox-svg"
            >
              &nbsp;&nbsp;
            </div>
            <div
              v-else-if="
                propertyName.startsWith('INITIATION DATE') ||
                propertyName.startsWith('TRANSACTION DATE') ||
                propertyName.startsWith('CREATED') ||
                propertyName.startsWith('EXPIRY') ||
                propertyName.startsWith('VNUBAN')
              "
            >
              <div>
                <p
                  class="upper-text"
                  :class="propertyName.startsWith('VNUBAN') ? 'darken' : ''"
                >
                  {{ value.split(" - ")[0] }}
                </p>
                <p>{{ value.split(" - ").slice(1, 3).join(" ") }}</p>
              </div>
            </div>
            <div
              :class="darkenAll ? 'darken' : ''"
              v-else-if="
                propertyName.startsWith('SOURCE ACCOUNT') ||
                propertyName.startsWith('PAYER ACCOUNT') ||
                propertyName.startsWith('DESTINATION ACCOUNT') ||
                (propertyName.startsWith('BANK') && propertyName !== 'BANK NAME')
              "
            >
              <div>
                <p class="upper-text">{{ value.split(" - ")[0] }}</p>
                <p>{{ value.split(" - ").slice(1, 3).join(" ") }}</p>
              </div>
            </div>
            <div v-else-if="propertyName.startsWith('VALUE / VOLUME')">
              <div class="flex-align-center">
                <p>{{ value.split(" - ")[0] }}</p>
                <p class="cover">
                  {{ value.split(" - ").slice(1, 3).join(" ") }}
                </p>
              </div>
            </div>
            <div v-else-if="propertyName === '' || propertyName === 'ACTIONS'">
              <slot v-bind:item="item" name="empty"></slot>
            </div>
            <div v-else-if="propertyName.startsWith('TRANSACTIONS')">
              <div class="type">
                {{ value.split(" ")[0]
                }}<span>{{ value.split(" ").slice(1, 3).join(" ") }}</span>
              </div>
            </div>
            <div v-else-if="propertyName.startsWith('AMOUNT')">
              <span :class="lightAmountColor ? '' : 'darken'">{{ value }}</span>
            </div>
            <div
                    :class="darkenAll ? 'darken' : ''"
                    v-else-if="propertyName.startsWith('INCOMING MERCHANTS')"
              class="flex-end"
            >
              <p class="type">{{ value.split("-")[0] }}</p>
              <p :style="{ padding: '0 10px' }">
                <svg
                  width="31"
                  height="8"
                  viewBox="0 0 31 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M30.3536 4.35355C30.5488 4.15829 30.5488 3.84171 30.3536 3.64645L27.1716 0.464466C26.9763 0.269204 26.6597 0.269204 26.4645 0.464466C26.2692 0.659728 26.2692 0.976311 26.4645 1.17157L29.2929 4L26.4645 6.82843C26.2692 7.02369 26.2692 7.34027 26.4645 7.53553C26.6597 7.7308 26.9763 7.7308 27.1716 7.53553L30.3536 4.35355ZM0 4.5H30V3.5H0L0 4.5Z"
                    fill="black"
                  />
                </svg>
              </p>
              <p class="type" v-if="value.split('-')[1].trim() !== 'infinity'">
                {{ value.split("-")[1] }}
              </p>
              <p v-else>
                <svg
                  width="20"
                  height="9"
                  viewBox="0 0 20 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.7142 0C13.4821 0 11.0714 2.16215 9.99998 3.245C8.92855 2.16215 6.51784 0 4.28571 0C1.60216 0 0 1.60216 0 4.28571C0 6.96926 1.60216 8.57142 4.28571 8.57142C6.51784 8.57142 8.92855 6.40927 9.99998 5.32642C11.0714 6.40927 13.4821 8.57142 15.7142 8.57142C18.3978 8.57142 20 6.96926 20 4.28571C20 1.60216 18.3978 0 15.7142 0ZM4.28567 7.14286C2.38995 7.14286 1.42851 6.18142 1.42851 4.28571C1.42851 2.38999 2.38995 1.42856 4.28567 1.42856C5.85711 1.42856 7.9428 3.19926 9.01996 4.28571C7.94497 5.37359 5.86351 7.14286 4.28567 7.14286ZM15.7142 7.14286C14.1428 7.14286 12.0571 5.37216 10.98 4.28571C12.0514 3.19859 14.1364 1.42856 15.7142 1.42856C17.61 1.42856 18.5714 2.38999 18.5714 4.28571C18.5714 6.18142 17.61 7.14286 15.7142 7.14286Z"
                    fill="black"
                  />
                </svg>
              </p>
            </div>
            <div
                    :class="darkenAll ? 'darken' : ''"
                    v-else-if="propertyName === 'PREEXISTING MERCHANTS'"
                    class="flex-center"
            >
              {{ value }}
            </div>
            <div
                    :class="darkenAll ? 'darken' : ''"
                    v-else-if="typeof value !== 'string' && value.isHtml"
                    class="flex-center"
                    v-html="value.isHtml"
            />
            <span :class="darkenAll ? 'darken' : ''" v-else>{{ value }}</span>
          </td>
        </router-link>
        <tr v-if="noClickEvent">
          <td
            v-for="(value, propertyName, index) in item"
            :key="index"
            :class="propertyName == 'id' && !displayId ? 'display-none' :  propertyName === 'STATUS' ? 'smaller-td' :''"
          >
            <div v-if="propertyName === 'STATUS'">
              <StatusIndicator :type="value" />
            </div>
            <div v-else-if="propertyName.startsWith('checkbox')">
              <Checkbox
                :onChecked="onChecked"
                :id="item.id"
                :rowSelected="rowSelected"
              />
            </div>
            <div
                    v-else-if="
                propertyName.startsWith('nocheckbox')
              "
                    class="checkbox-svg"
            >
              &nbsp;&nbsp;
            </div>
            <div
              v-else-if="
                propertyName.startsWith('INITIATION DATE') ||
                propertyName.startsWith('TRANSACTION DATE') ||
                propertyName.startsWith('CREATED') ||
                propertyName.startsWith('EXPIRY') ||
                propertyName.startsWith('VNUBAN')
              "
            >
              <div>
                <p
                  class="upper-text"
                  :class="propertyName.startsWith('VNUBAN') ? 'darken' : ''"
                >
                  {{ value.split(" - ")[0] }}
                </p>
                <p>{{ value.split(" - ").slice(1, 3).join(" ") }}</p>
              </div>
            </div>
            <div
              v-else-if="
                propertyName.startsWith('SOURCE ACCOUNT') ||
                propertyName.startsWith('DESTINATION ACCOUNT') ||
                (propertyName.startsWith('BANK') && propertyName !== 'BANK NAME') ||
                propertyName.startsWith('BENEFICIARY') ||
                propertyName.startsWith('SOURCE VNUBAN')
              "
            >
              <div>
                <p class="upper-text">{{ value.split(" ")[0] }}</p>
                <p>{{ value.split(" ").slice(1, 3).join(" ") }}</p>
              </div>
            </div>
            <div v-else-if="propertyName.startsWith('VALUE / VOLUME')">
              <div>
                <p class="upper-text">{{ value.split(" - ")[0] }}</p>
                <p>{{ value.split(" - ").slice(1, 3).join(" ") }}</p>
              </div>
            </div>
            <div v-else-if="propertyName === '' || propertyName === 'ACTIONS'">
              <slot v-bind:item="item" name="empty"></slot>
            </div>
            <div v-else-if="propertyName.startsWith('TRANSACTIONS')">
              <div class="type">
                {{ value.split(" ")[0]
                }}<span>{{ value.split(" ").slice(1, 3).join(" ") }}</span>
              </div>
            </div>
            <div v-else-if="propertyName.startsWith('AMOUNT')">
              <span :class="lightAmountColor ? '' : 'darken'">{{ value }}</span>
            </div>

            <div
                    :class="darkenAll ? 'darken' : ''"
                    v-else-if="typeof value !== 'string' && value.isHtml"
                    class="flex-center"
                    v-html="value.isHtml"
            />
            <span v-else>{{ value }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="table__details"
      v-if="(!loading && !toggleContent && !hidePagination && contents.length ) || (toggleContent && state.showContents && !loading && !hidePagination && contents.length)"
    >
      <div class="table__details__left">
        <span class="text-muted"
          >Page {{ pageInfo.current_page }} of {{ pageInfo.total_pages }}</span
        >
      </div>
      <div class="table__details__right">
        <Pagination :useQuery="useQuery" :handlePageChange="handlePageChange" :numberOfPages="pageInfo.total_pages" />
      </div>
      <div class="table__details__right"></div>
    </div>
    <div v-if="!contents.length && !loading">
      <slot name="nocontent"></slot>
    </div>
    <div v-if="showFooter">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
import { reactive } from "@vue/composition-api";
import Button from "@/components/button.vue";
import Checkbox from "@/components/checkbox.vue";
import { capitalize, capitalizeFirstLetter } from "@/lib/capitalize";
import NoContent from "@/components/noContent.vue";
import Pagination from "@/components/pagination.vue";
import StatusIndicator from "@/components/status-indicator.vue";
export default {
  setup(props) {
    const state = reactive({
      showExportOptions: false,
      exportDisabled: false,
      openFilters: false,
      showContents: false,
    });
    const onChecked = (e) => {
      props.onRowChecked(e);
    };
    const exportfile = (type) => {
      props.handleExportDownload(type);
      state.showExportOptions = false;
    };
    const clearFilterHandler = () => {
      state.openFilters = false;
      props.clearFilter();
    };
    const generatePaginationLink = () => {};
    return {
      polling: "",
      onChecked,
      state,
      exportfile,
      clearFilterHandler,
      generatePaginationLink,
    };
  },
  components: {
    Button,
    Checkbox,
    NoContent,
    Pagination,
    StatusIndicator,
  },
  props: {
    contents: Array,
    title: String,
    showFliter: Boolean,
    showExport: Boolean,
    pageInfo: Object,
    onPageChange: Function,
    primaryButtonName: String,
    handlePrimaryButtonClick: Function,
    handleExportDownload: Function,
    clearFilter: Function,
    singleDetailRouteName: String,
    onRowChecked: Function,
    rowSelected: Array,
    handlePrimaryButtonDisabled: Boolean,
    checkboxAll: Function,
    checkboxNone: Function,
    routerClickEvent: String,
    hidePrimaryButton: Boolean,
    loading: Boolean,
    noClickEvent: Boolean,
    hideTableTop: Boolean,
    tableContentLoading: Boolean,
    hidePagination: Boolean,
    showFooter: Boolean,
    lightAmountColor: Boolean,
    additionalRouteName: String,
    additionalRouteKey: String,
    darkenAll: Boolean,
    displayId: Boolean,
    hideTableContentTop: Boolean,
    toggleContent: Boolean,
    hideFilter: Boolean,
    useQuery: {
      type: Boolean,
      default: true
    },
    handlePageChange: {
      type: Function,
      default: () => {}
    },
    paramsObject: Object,
    forceFilterSlot: Boolean,
  },
  methods: {
    linkGen(pageNum) {
      return "?page=" + pageNum;
    },
    capitalize,
    capitalizeFirstLetter,
  },
};
</script>
<style lang="scss" scoped>
.table-component {
  margin: 0 20px;
  background: #ffffff;
  // border: 1px solid rgba(97, 110, 124, 0.2);
  box-sizing: border-box;
  // box-shadow: 0px 8px 14px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  width: fit-content;
  min-width: 95%;
  p {
    line-height: 24px;
  }
  .show-export {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    .export-options {
      background: #fff;
      z-index: 100;
      padding: 10px;
      box-shadow: 0 0 0 0 0.05;
      position: absolute;
      bottom: -85px;
      width: 93px;
      right: 0;
      border: 1px solid #dfe2e5;
      border-radius: 4px;
      &__option {
        padding: 8px 0;
        color: #e00b5b;
        font-size: 12px;
        cursor: pointer;
      }
    }
  }
  .darken {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #261940;
  }
  .tab {
    &__content {
      td {
        span {
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
          color: rgba(38, 25, 64, 0.6);
        }
        .time {
          font-size: 12px;
        }
      }
      &__top {
        &__right {
          .button-comp {
            margin-left: 20px;
          }
        }

        &__left {
          display: flex;
          align-items: center;
          svg {
            margin-right: 16px;
            cursor: pointer;
          }
        }

      }
      .checkbox-svg {
        cursor: pointer;
      }
      .upper-text {
        font-style: normal;
        font-weight: normal;
        font-size: 10px;
        line-height: 20px;
        color: rgba(38, 25, 64, 0.6);
      }
      &__top__item {
        display: flex;
        align-items: center;
      }
      .green {
        background-color: #f5fcfb;
      }
      ul {
        margin: 0;
        padding: 0;
      }
      input {
        max-width: 120px;
      }
      .flex {
        display: flex;
        align-items: center;
      }
      .darken {
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 20px;
        color: rgba(38, 25, 64, 0.6);
      }
      .pending {
        color: #ff9a02;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
      }
      .active {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        color: #e00b5b;
      }
      .inactive {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        text-align: right;
        color: #f36b7f;
      }
      .type {
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 20px;
        color: rgba(38, 25, 64, 0.6);
        span {
          border-radius: 15px;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
          color: rgba(38, 25, 64, 0.6);
          text-align: center;
          padding: 5px;
        }
      }
      white-space: nowrap !important;
      word-break: keep-all !important;
      word-wrap: unset;
    }
    .arrow-right {
      margin: 0 15px;
    }
  }
}
.cover {
  display: flex;
  justify-content: flex-end;
  p {
    background: rgba(38, 25, 64, 0.15);
    border-radius: 15px;
    width: fit-content;
    padding: 5px 7px;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
  }
}
.flex-center {
  display: flex;
  justify-content: center;
}
.flex-end {
  display: flex;
  justify-content: flex-end;
  p {
    width: 50px;
  }
  p:first-child {
    text-align: end;
  }
  p:last-child {
    text-align: start;
  }
}
.display-none {
  display: none;
}
  .smaller-td {
    padding:18px 4px 18px 4px !important;
  }
</style>